export default function PageHeader({ eyebrow, title, description, actions, metadata }) {
  return (
    <header className="page-header">
      <div className="page-header-copy">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {metadata && <div className="page-header-metadata">{metadata}</div>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  )
}
